import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Не оплачены ")
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Оплачены, услуги не выданы ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Просрочен счёт ")
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Счёт ")
const _hoisted_5 = {
  key: 0,
  class: "text-muted"
}
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Картой онлайн ")
const _hoisted_7 = { class: "text-muted" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" Открыть ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_payment_status_tag = _resolveComponent("payment-status-tag")!
  const _component_new_tab_link = _resolveComponent("new-tab-link")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_payment_list_layout = _resolveComponent("payment-list-layout")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_payment_list_layout, {
    page: _ctx.page,
    pages: _ctx.pages,
    "per-page": _ctx.perPage,
    total: _ctx.total,
    onApply: _ctx.apply,
    onReset: _ctx.reset,
    onPageChange: _ctx.setPage
  }, {
    filter: _withCtx(() => [
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.number,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filters.number) = $event)),
        placeholder: "Номер заказа",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.user_id,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.filters.user_id) = $event)),
        placeholder: "ID пользователя",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: _ctx.filters.status,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.filters.status) = $event)),
        multiple: "",
        clearable: "",
        placeholder: "Статус"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.statusOptions, (o) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: o.value,
              label: o.label,
              value: o.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: _ctx.filters.payer_type,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filters.payer_type) = $event)),
        clearable: "",
        placeholder: "Плательщик"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payerOptions, (o) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: o.value,
              label: o.label,
              value: o.value
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.filters.created_from,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filters.created_from) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "Создан с"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.filters.created_to,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filters.created_to) = $event)),
        type: "date",
        "value-format": "YYYY-MM-DD",
        placeholder: "Создан по"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.amount_from,
        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.filters.amount_from) = $event)),
        placeholder: "Сумма от",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.amount_to,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filters.amount_to) = $event)),
        placeholder: "Сумма до",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        modelValue: _ctx.filters.gateway_transaction_id,
        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.filters.gateway_transaction_id) = $event)),
        placeholder: "ID платежа в ЮKassa",
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.filters.unpaid,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.filters.unpaid) = $event))
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.filters.stuck,
        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.filters.stuck) = $event))
      }, {
        default: _withCtx(() => [
          _hoisted_2
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _createVNode(_component_el_checkbox, {
        modelValue: _ctx.filters.overdue_invoice,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.filters.overdue_invoice) = $event))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createBlock(_component_el_table, {
        border: "",
        data: _ctx.items,
        "table-layout": "fixed"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            label: "№",
            width: "90",
            prop: "number"
          }),
          _createVNode(_component_el_table_column, {
            label: "Статус",
            width: "160"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_payment_status_tag, {
                kind: "order",
                status: row.status
              }, null, 8, ["status"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Оплата",
            width: "170"
          }, {
            default: _withCtx(({ row }) => [
              (row.payer_type === 'legal')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _hoisted_4,
                    (_ctx.invoiceOf(row))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, " № " + _toDisplayString(_ctx.invoiceOf(row).number) + ", до " + _toDisplayString(_ctx.date(_ctx.invoiceOf(row).due_at)), 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _hoisted_6
                  ], 64)),
              _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.payerLabels[row.payer_type]), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Пользователь",
            width: "120"
          }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_new_tab_link, {
                to: { name: 'users-edit', params: { id: row.user_id }, query: { tab: 'payments' } }
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(row.user_id), 1)
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Состав",
            "min-width": "220"
          }, {
            default: _withCtx(({ row }) => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(row.items, (item) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: item.id
                }, _toDisplayString(item.name), 1))
              }), 128))
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Сумма",
            width: "140",
            align: "right"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.money(row.amount)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "Создан",
            width: "150"
          }, {
            default: _withCtx(({ row }) => [
              _createTextVNode(_toDisplayString(_ctx.dateTime(row.created_at)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, { width: "110" }, {
            default: _withCtx(({ row }) => [
              _createVNode(_component_new_tab_link, {
                button: "",
                to: { name: 'payments-orders-view', params: { id: row.id } }
              }, {
                default: _withCtx(() => [
                  _hoisted_8
                ]),
                _: 2
              }, 1032, ["to"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data"])), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _: 1
  }, 8, ["page", "pages", "per-page", "total", "onApply", "onReset", "onPageChange"]))
}